export default {
  "dashboard.title": "Tekrar hoş geldiniz",
  "dashboard.noAccount.title": "PAMM Hesabınızı Ekleyin",
  "dashboard.noAccount.description": "Kullanıcınızı aktifleştirmek ve TheClub avantajlarından yararlanmak için aktif bir yatırım PAMM hesabına ihtiyacınız var",
  "dashboard.noAccount.skipButton": "Atla",
  "dashboard.noAccount.addAccountButton": "PAMM Hesabı Ekle",
  "dashboard.subtitle": "The Club ile geleceğinizi inşa edin",
  "dashboard.totalEarnings.lifetime": "Toplam Ömür Boyu Kazançlar",
  "dashboard.totalEarnings.lastMonth": "Toplam Kazançlar",
  "dashboard.totalEarnings.breakdown.accounts": "Trading Hesap Kârları",
  "dashboard.totalEarnings.breakdown.commissions": "Topluluk Komisyonlarınız",
  "dashboard.community.combined.title": "Topluluk Genel Bakış",
  "dashboard.userInfo.combined.title": "Profil",
  "dashboard.charts.totalEarningsOverTime": "Zaman İçinde Toplam Kazançlar",
  "dashboard.userProfile.title": "Profil Genel Bakış",
  "dashboard.userProfile.username": "Kullanıcı Adı",
  "dashboard.userProfile.memberSince": "Üyelik Başlangıcı",
  "dashboard.userProfile.rank": "Rütbe",
  "dashboard.userProfile.status": "Durum",
  "dashboard.userStats.title": "Hızlı İstatistikler",
  "dashboard.userStats.referralLink": "Referans Bağlantısı",
  "dashboard.userStats.commissionModel": "Komisyon Modeli",
  "dashboard.userStats.communityValue": "Topluluk Değeri",
  "dashboard.userStats.linkCopied": "Bağlantı Kopyalandı!",
  "dashboard.userStats.linkCopiedDesc": "Referans bağlantısı panoya kopyalandı",
  "dashboard.userStats.rank": "Rütbe",
  "dashboard.profits.lifetime": "Trading Hesap Ömür Boyu Kârları",
  "dashboard.profits.lastMonth": "Trading Hesap Geçen Ay Kârları",
  "dashboard.profits.accountsProfits.title": "Trading Hesap Kârları",
  "dashboard.profits.commissions.title": "Topluluk Komisyonlarınız",
  "dashboard.commissions.lifetime": "Ömür Boyu Komisyonlar",
  "dashboard.commissions.lastMonth": "Komisyonlar",
  "dashboard.commissions.lastMonthWithMonth": "Komisyonlar",
  "dashboard.commissions.currentBalance": "Mevcut Bakiye",
  "dashboard.commissions.totalPaid": "Toplam Ödenen",
  "dashboard.community.totalReferrals": "Toplam Referanslar",
  "dashboard.community.totalReferralsDesc": "Tüm Kademeler Birleşik",
  "dashboard.community.communityValue": "Topluluk Değeriniz",
  "dashboard.community.communityValueDesc": "Topluluğunuzun Toplam Değeri",
  "dashboard.mycommunity.title": "Topluluğum",
  "dashboard.charts.profitsOverTime": "Zaman İçinde Trading Hesap Kârları",
  "dashboard.charts.commissionsOverTime": "Zaman İçinde Komisyonlar",
  "dashboard.charts.accountProfit": "Trading Hesap Kârı",
  "dashboard.charts.totalEarnings": "Toplam Kazançlar",
  "dashboard.charts.commissionAmount": "Komisyon Tutarı",
  "dashboard.months.jan": "Oca",
  "dashboard.months.feb": "Şub",
  "dashboard.months.mar": "Mar",
  "dashboard.months.apr": "Nis",
  "dashboard.months.may": "May",
  "dashboard.months.jun": "Haz",
  "dashboard.months.jul": "Tem",
  "dashboard.months.aug": "Ağu",
  "dashboard.months.sep": "Eyl",
  "dashboard.months.oct": "Eki",
  "dashboard.months.nov": "Kas",
  "dashboard.months.dec": "Ara",
  "dashboard.monthsFull.jan": "Ocak",
  "dashboard.monthsFull.feb": "Şubat",
  "dashboard.monthsFull.mar": "Mart",
  "dashboard.monthsFull.apr": "Nisan",
  "dashboard.monthsFull.may": "Mayıs",
  "dashboard.monthsFull.jun": "Haziran",
  "dashboard.monthsFull.jul": "Temmuz",
  "dashboard.monthsFull.aug": "Ağustos",
  "dashboard.monthsFull.sep": "Eylül",
  "dashboard.monthsFull.oct": "Ekim",
  "dashboard.monthsFull.nov": "Kasım",
  "dashboard.monthsFull.dec": "Aralık",
  "dashboard.loading": "Kontrol paneli verileri yükleniyor...",
  "dashboard.error": "Kontrol paneli verileri yüklenirken hata",
  "dashboard.status.active": "Aktif",
  "dashboard.status.inactive": "Pasif",
  "dashboard.profits.lastMonthWithMonth": "Trading Hesap Kârları",
};
